var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-file',{attrs:{"accept":".jpg,.jpeg,.png,.webp"},on:{"change":_vm.handleFileChange}}),(_vm.previewUrl)?_c('div',{staticClass:"mt-3"},[_c('img',{staticClass:"w-100 rounded",staticStyle:{"max-height":"220px","object-fit":"cover"},attrs:{"src":_vm.previewUrl,"alt":"Preview"}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }